import React from 'react';
import { t } from '../../../../modules/infra/i18n';

export default () => (
  <div className="c-heading c-heading--small u-mt">
    {t('services:list.empty.message')}
  </div>
);
